import { NAVIGATION_DRAWER_WIDTH } from '@/ui/layout/navigation-drawer/constants/NavigationDrawerWidth';
import { createAtomState } from '@/ui/utilities/state/jotai/utils/createAtomState';

export const navigationDrawerWidthState = createAtomState<number>({
  key: 'navigationDrawerWidthState',
  defaultValue: NAVIGATION_DRAWER_WIDTH.default,
  persistInLocalStorage: true,
});
